module.exports = __webpack_public_path__ + "static/media/approved.7e59dd20.png";